import { render } from "./label.vue?vue&type=template&id=22faca36&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"

import "./label.vue?vue&type=style&index=0&id=22faca36&scoped=true&lang=less"
import "./label.vue?vue&type=style&index=1&id=22faca36&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22faca36"]])

export default __exports__